/**
 * Mock-датасет клиентов под дизайн (design_handoff_02_clients). 11 записей
 * из макета — покрывают оба типа и все статусы подписки. Когда подключим
 * `GET /admin/clients` — файл перестаёт использоваться.
 */

import type {ClientListItem} from './types';

/** Справочник городов (city из БД, ADMIN_BACKEND_SPEC §3.9). */
export const CITY_OPTIONS = [
  'Бишкек',
  'Ош',
  'Джалал-Абад',
  'Каракол',
  'Токмок',
  'Нарын',
  'Талас',
  'Кара-Балта',
  'Балыкчы',
] as const;

/** Справочник тарифов (коарс, для фильтра). */
export const TARIFF_OPTIONS = ['Соло', 'Клиника'] as const;

const clinic = (
  id: string,
  name: string,
  phone: string,
  city: string,
  seatsUsed: number,
  seatsLimit: number,
  patients: number,
  revenue: number,
  status: ClientListItem['subscriptionStatus'],
  periodEnd: string | null,
  trialDay: number | null = null,
): ClientListItem => ({
  id,
  type: 'clinic',
  name,
  adminFullName: name,
  adminPhone: phone,
  cityName: city,
  tariffName: 'Клиника',
  tariffLabel: 'Клиника',
  seatsUsed,
  seatsLimit,
  patientsCount: patients,
  revenue,
  lifetimeRevenue: null,
  subscriptionStatus: status,
  trialDay,
  lastActiveAt: '2026-07-02T09:00:00Z',
  createdAt: '2025-10-01T10:00:00Z',
  currentPeriodEnd: periodEnd,
});

const solo = (
  id: string,
  name: string,
  phone: string,
  city: string,
  patients: number,
  revenue: number,
  status: ClientListItem['subscriptionStatus'],
  periodEnd: string | null,
  trialDay: number | null = null,
): ClientListItem => ({
  id,
  type: 'solo',
  name,
  adminFullName: name,
  adminPhone: phone,
  cityName: city,
  tariffName: 'Соло',
  tariffLabel: 'Соло',
  seatsUsed: 1,
  seatsLimit: null,
  patientsCount: patients,
  revenue,
  lifetimeRevenue: null,
  subscriptionStatus: status,
  trialDay,
  lastActiveAt: '2026-07-01T18:00:00Z',
  createdAt: '2026-06-01T09:00:00Z',
  currentPeriodEnd: periodEnd,
});

export const MOCK_CLIENTS: ClientListItem[] = [
  clinic(
    'c-1',
    'Дентал Плюс',
    '+996 700 120 340',
    'Бишкек',
    7,
    10,
    1240,
    312_000,
    'active',
    '2026-07-24',
  ),
  solo('c-2', 'Асанов Бакыт', '+996 555 981 210', 'Ош', 186, 42_000, 'trial', '2026-07-20', 12),
  clinic(
    'c-3',
    'Ак-Тиш',
    '+996 770 445 900',
    'Бишкек',
    12,
    12,
    2980,
    690_000,
    'active',
    '2026-08-03',
  ),
  solo('c-4', 'Иманова Асель', '+996 500 332 118', 'Каракол', 64, 9_500, 'awaiting_card', null),
  clinic(
    'c-5',
    'Смайл Студия',
    '+996 707 210 556',
    'Джалал-Абад',
    4,
    5,
    820,
    165_000,
    'past_due',
    '2026-06-28',
  ),
  clinic(
    'c-6',
    'Ортодонт Люкс',
    '+996 555 700 401',
    'Бишкек',
    9,
    10,
    1760,
    430_000,
    'active',
    '2026-07-15',
  ),
  solo('c-7', 'Мамытов Эрлан', '+996 771 009 233', 'Токмок', 240, 51_000, 'active', '2026-07-11'),
  clinic('c-8', 'Дент-Арт', '+996 700 884 512', 'Ош', 3, 6, 540, 98_000, 'blocked', null),
  solo(
    'c-9',
    'Керимова Нургуль',
    '+996 505 220 877',
    'Бишкек',
    128,
    22_500,
    'trial',
    '2026-07-28',
    4,
  ),
  clinic(
    'c-10',
    'Медстом Центр',
    '+996 772 341 660',
    'Бишкек',
    15,
    15,
    3420,
    812_000,
    'active',
    '2026-08-09',
  ),
  solo('c-11', 'Осмонов Тилек', '+996 555 118 902', 'Нарын', 0, 0, 'cancelled', null),
];
